import { DROP_SPLASH_MS } from "./constants.js";
import * as C from "../../config/constants.js";
import { FlaskRenderer } from "../flask-renderer.js";

export function drawSystem(system, ctx, renderOpts) {
  system.ensureEngine();
  var renderer = system.opts.renderer || FlaskRenderer;
  var extraOpts = renderOpts || {};
  if (renderer && renderer.draw) {
    renderer.draw(ctx, Object.assign({
      bounds: system.bounds,
      bodies: system.bodies,
      bodyRadiusByTier: system.bodyRadiusByTier,
      evolutionChain: system.evolutionChain,
      mergeFlashPos: system.mergeFlashPos,
      mergeFlashUntil: system.mergeFlashUntil,
      mergeFlashRadius: system.mergeFlashRadius,
      mergeParticles: system.mergeParticles,
      mergeParticlesStart: system.mergeParticlesStart,
      mergeParticlesUntil: system.mergeParticlesUntil,
      mergeMotionDraw: system.mergeMotionDraw,
      shrinkMotionDraw: system.shrinkMotionDraw,
      dropSplashParticles: system.dropSplashParticles,
      dropSplashUntil: system.dropSplashUntil,
      dropSplashStart: system.dropSplashStart,
      dropSplashDuration: DROP_SPLASH_MS,
      flaskWallThickness: system.flaskWallThickness,
      flaskGeometry: system._flaskGeometry,
      mouthSealBody: system.mouthSealBody,
      tierColors: C.MERGE_PICKUP_COLORS || [],
    }, extraOpts));
  }
}
